import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import { Routes } from '@share/constants';

import { RewardsHero } from '../rewards-hero';

import './style.scss';

interface IProps {
  accountName?: string;
}

export function RewardsLearnContent(props: IProps) {
  const { accountName } = props;
  const rewardsPath = accountName ? `/${accountName}${Routes.Rewards}` : '#';

  return (
    <article className="rewards-learn-content">
      <Link to={rewardsPath} className="rewards-learn-content__back">
        <FontAwesomeIcon icon={faArrowLeft} className="rewards-learn-content__back-icon" />
        <FormattedMessage id="rewardsLearn.backToRewards" />
      </Link>

      <RewardsHero accountName={accountName} />

      <h1 className="rewards-learn-content__main-title">
        <FormattedMessage id="rewardsLearn.title" />
      </h1>

      <p className="rewards-learn-content__intro">
        <FormattedMessage id="rewardsLearn.intro" />
      </p>

      <section className="rewards-learn-content__section">
        <h2 className="rewards-learn-content__section-title">
          <FormattedMessage id="rewardsLearn.s1Title" />
        </h2>
        <p>
          <FormattedMessage id="rewardsLearn.s1P1" />
        </p>
        <p>
          <FormattedMessage id="rewardsLearn.s1P2" />
        </p>
        <p>
          <FormattedMessage id="rewardsLearn.s1P3" />
        </p>
        <p>
          <FormattedMessage id="rewardsLearn.s1Terms" />
        </p>
      </section>

      <section className="rewards-learn-content__section">
        <h2 className="rewards-learn-content__section-title">
          <FormattedMessage id="rewardsLearn.s2Title" />
        </h2>
        <p>
          <FormattedMessage id="rewardsLearn.s2P1" />
        </p>
        <p className="rewards-learn-content__strong-label">
          <FormattedMessage id="rewardsLearn.importantToKnow" />
        </p>
        <ul>
          <li><FormattedMessage id="rewardsLearn.s2Bullet1" /></li>
          <li><FormattedMessage id="rewardsLearn.s2Bullet2" /></li>
          <li><FormattedMessage id="rewardsLearn.s2Bullet3" /></li>
          <li><FormattedMessage id="rewardsLearn.s2Bullet4" /></li>
        </ul>
        <p>
          <FormattedMessage id="rewardsLearn.s2P2" />
        </p>
      </section>

      <section className="rewards-learn-content__section">
        <h2 className="rewards-learn-content__section-title">
          <FormattedMessage id="rewardsLearn.s3Title" />
        </h2>
        <p>
          <FormattedMessage id="rewardsLearn.s3P1" />
        </p>
        <ol>
          <li><FormattedMessage id="rewardsLearn.s3Step1" /></li>
          <li><FormattedMessage id="rewardsLearn.s3Step2" /></li>
          <li><FormattedMessage id="rewardsLearn.s3Step3" /></li>
          <li><FormattedMessage id="rewardsLearn.s3Step4" /></li>
          <li><FormattedMessage id="rewardsLearn.s3Step5" /></li>
          <li><FormattedMessage id="rewardsLearn.s3Step6" /></li>
          <li><FormattedMessage id="rewardsLearn.s3Step7" /></li>
        </ol>
        <p className="rewards-learn-content__strong-label">
          <FormattedMessage id="rewardsLearn.s3Important" />
        </p>
        <p>
          <FormattedMessage id="rewardsLearn.s3P2" />
        </p>
      </section>

      <section className="rewards-learn-content__section">
        <h2 className="rewards-learn-content__section-title">
          <FormattedMessage id="rewardsLearn.exampleTitle" />
        </h2>
        <p>
          <FormattedMessage id="rewardsLearn.exampleP1" />
        </p>
        <p>
          <FormattedMessage id="rewardsLearn.exampleP2" />
        </p>
      </section>

      <section className="rewards-learn-content__section">
        <h2 className="rewards-learn-content__section-title">
          <FormattedMessage id="rewardsLearn.summaryTitle" />
        </h2>
        <ul>
          <li><FormattedMessage id="rewardsLearn.summary1" /></li>
          <li><FormattedMessage id="rewardsLearn.summary2" /></li>
          <li><FormattedMessage id="rewardsLearn.summary3" /></li>
          <li><FormattedMessage id="rewardsLearn.summary4" /></li>
          <li><FormattedMessage id="rewardsLearn.summary5" /></li>
        </ul>
      </section>
    </article>
  );
}
